<template>
    <v-sheet color="white" class="pa-1">

        <v-row>
            <v-col>
                <v-autocomplete :items="getAllClientes" v-model="editedItem.nit" dense color="blue" outlined
                    clearable hide-details hide-selected :item-text="getItemText" item-value="nit"
                    @change="setDatos()" label="Buscar Cliente">
                    <template v-slot:no-data>
                        
                        <v-list-item>
                            <v-list-item-title>
                                <strong>No se contro ningun registro </strong>

                                <v-spacer></v-spacer>
                                <v-btn small dark color="blue" @click="$router.push({name:'CrearEditarPersona'})">
                                    <v-icon>mdi-account-plus</v-icon>
                                    Crear
                                </v-btn>

                            </v-list-item-title>
                        </v-list-item>
                    </template>
                </v-autocomplete>
            </v-col>
        </v-row>

        <v-text-field v-model="editedItem.cliente" label="Nombre Cliente"></v-text-field>
        <v-text-field v-model="editedItem.direccion" label="Dirección"></v-text-field>


    </v-sheet>
</template>
<script>
import { mapGetters } from 'vuex';
export default {
    name: "DatosCliente",
    data: () => ({
        editedItem: { 
            idpersona:1,          
            cliente: "CONSUMIDOR FINAL",
            nit: "CF",
            codigo: '',
            direccion: "JALAPA",
        },
        defaultItem: {
            idpersona:1,
            cliente: "CONSUMIDOR FINAL",
            nit: "CF",
            codigo: '',
            direccion: "JALAPA",
        },

    }),
    async created() {
        await this.main()
    },
    computed: {
        ...mapGetters(["getAllClientes", "getTokenUser", "getEstablecimientosActivas"]),
        getUrlPdf() {
            return this.$store.getters.getUrlPdf
        }
    },
    methods: {
        async main() {
            await this.$store.dispatch("setClientes");
            this.$emit('setcliente',this.editedItem)
        },
        getItemText(item) {
            return `${item.nit} - ${item.nombre}`;
        },
        setDatos() {
          
            const {nombre,direccion,idpersona} = this.$store.getters.getClientes(
                                            this.editedItem.nit.toUpperCase()
                                        );

                                        
            this.editedItem.idpersona = idpersona               
            this.editedItem.cliente = nombre               
            this.editedItem.direccion = direccion               
            this.$emit('setcliente',this.editedItem)
        },
    }
}

</script>